import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import '../../styles/core.scss';
import css from './index.scss';
import SvgIcon from '../svg-icon/svg-icon';
import messages from './messages';
import { PrintSignIn } from '../../helpers/icon-dictionary';
import Button from '../button';
import { DARK } from '../button/variants';

class Summary extends Component {
    constructor(props) {
        super(props);
        this.content = null;
        this.setContentRef = (element) => {
            this.content = element;
        };
    }

    handleOnPrint = () => {
        if (this.content) {
            window.print();
        }
    }

    render() {
        const { intl, message, children, icon, handleOnCloseModal, handleOnBack, handleOnViewSummary,
            rollOverValidationPage, rollOverConfirmationPage, quickUploadErrorPage } = this.props;

        const buttons = {};

        if (rollOverValidationPage) {
            buttons.backButtonStyle = `${css.button}`;
            buttons.printButtonStyle = `${css.button}`;
            buttons.doneButtonStyle = `${css.hidden}`;
            buttons.viewSummaryButtonStyle = `${css.hidden}`;
        } else if (rollOverConfirmationPage) {
            buttons.viewSummaryButtonStyle = `${css.viewSummary}`;
            buttons.printButtonStyle = `${css.button}`;
            buttons.doneButtonStyle = `${css.hidden}`;
            buttons.backButtonStyle = `${css.hidden}`;
        } else {
            buttons.viewSummaryButtonStyle = `${css.hidden}`;
            buttons.printButtonStyle = `${css.hidden}`;
            buttons.doneButtonStyle = `${css.button}`;
            buttons.backButtonStyle = `${css.hidden}`;
        }

        return (
            <div className={css.uploadValidationContainer}>
                <div className={css.svg}>
                    <SvgIcon icon={icon} />
                </div>
                <div className={css.errorMessage}>
                    {message}
                </div>
                <div className={css.errorMessagesWrapper} ref={this.setContentRef}>
                    <div className={css.errorMessagesRow}>
                        {children}
                    </div>
                </div>
                <div className={css.buttonPanel}>
                    <div className={css.leftPanel}>
                        <button
                            className={buttons.backButtonStyle}
                            onClick={handleOnBack}
                        >{intl.formatMessage(messages.back)}</button>
                        <button
                            className={buttons.viewSummaryButtonStyle}
                            onClick={handleOnViewSummary}
                        >{intl.formatMessage(messages.ViewSummary)}</button>
                    </div>
                    <div className={css.rightPanel}>
                        <div className={quickUploadErrorPage ? css.hidden : ''}>
                            <Button
                                handleOnClick={this.handleOnPrint}
                                icon={PrintSignIn}
                                label={intl.formatMessage(messages.print)}
                                variant={DARK} />
                        </div>
                    </div>
                    <div className={css.done}>
                        <button
                            className={buttons.doneButtonStyle}
                            onClick={handleOnCloseModal}
                        >{intl.formatMessage(messages.ok)}</button>
                    </div>
                </div>
            </div>
        );
    }
}

Summary.propTypes = {
    handleOnCloseModal: PropTypes.func,
    handleOnBack: PropTypes.func,
    handleOnViewSummary: PropTypes.func,
    icon: PropTypes.string,
    message: PropTypes.string,
    intl: intlShape.isRequired,
    children: PropTypes.node,
    rollOverValidationPage: PropTypes.bool,
    rollOverConfirmationPage: PropTypes.bool,
    quickUploadErrorPage: PropTypes.bool
};

export default injectIntl(Summary);



// WEBPACK FOOTER //
// ./app/components/upload-summary/index.js